import styled from "styled-components";
import { Draggable } from "react-beautiful-dnd";

export const OptionsWrapper = styled.div`
  width: 100%;
  min-height: 100px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

export const OptionWrapper = styled(Draggable)`
  background-color: red;
  width: 100%;
`;

export const StepList = styled.div`
  padding: 2px 0;

  & .step {
    font-weight: 600;
    display: inline-block;
    font-size: 12px;
    margin-right: 10px;
  }
  & p {
    display: inline-block;
    font-size: 12px;
  }
`;
